import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hot",
  "use": "icon-hot-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-hot\"><defs><style type=\"text/css\"></style></defs><path d=\"M349.866667 934.4h298.666666C1109.333333 674.133333 763.733333 281.6 704 238.933333c21.333333 42.666667 25.6 119.466667-17.066667 153.6-68.266667-260.266667-238.933333-315.733333-238.933333-315.733333 17.066667 136.533333-76.8 281.6-166.4 392.533333 0-55.466667-4.266667-89.6-34.133333-140.8-4.266667 98.133333-81.066667 179.2-102.4 277.333334-25.6 128 21.333333 226.133333 204.8 328.533333z\" p-id=\"1872\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"icon-[name]"}!./src/assets/icons/svg/hot.svg
// module id = E5QA
// module chunks = 1